import React from 'react'
import { Link } from 'react-router-dom';

function ServiceSeven() {
    return (
        <div>
            {/* Working Process section start */}
            <div className="rts-working-process-section eight rts-section-gap" id='service'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="title-area">
                                <span>Our Values</span>
                                <h2 className="title">Why Choose Us?</h2>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <p className="decs">
                            At AQC, we provide tailored consultancy and third-party inspection services to optimize business performance. Our expert team offers innovative, results-driven solutions, helping businesses achieve their goals efficiently across the Middle East, Europe, and Asia. We focus on delivering cost-effective, high-quality services that drive growth and ensure compliance with international standards.
                            </p>
                        </div>
                    </div>
                    <div className="rts-working-process-inner">
                        <div className="row">
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                <div className="wrapper">
                                    <Link to={'/services'} className="icon">
                                        <img
                                            src="assets/images/working-step/icon/target.svg"
                                            alt="Icon"
                                        />
                                    </Link>
                                    <div className="content">
                                        <h5 className="title">Expert Professionals</h5>
                                        <p className="disc">
                                        Our team consists of certified experts with extensive industry experience.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                <div className="wrapper">
                                    <Link to={'/services'} className="icon">
                                        <img
                                            src="assets/images/working-step/icon/user.svg"
                                            alt="Icon"
                                        />
                                    </Link>
                                    <div className="content">
                                        <h5 className="title">Custom Solutions</h5>
                                        <p className="disc">
                                        We provide industry-specific, customized solutions to meet your business needs.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                <div className="wrapper">
                                    <Link to={'/services'} className="icon">
                                        <img
                                            src="assets/images/working-step/icon/save.svg"
                                            alt="Icon"
                                        />
                                    </Link>
                                    <div className="content">
                                        <h5 className="title">International Compliance</h5>
                                        <p className="disc">
                                       We Ensure Compliance with ISO 9001, 14001, 22000, OHSAS 18001, HACCP.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                <div className="wrapper">
                                    <Link to={'/services'} className="icon">
                                        <img
                                            src="assets/images/working-step/icon/goal.svg"
                                            alt="Icon"
                                        />
                                    </Link>
                                    <div className="content">
                                        <h5 className="title">Affordable & Reliable</h5>
                                        <p className="disc">
                                        Our services are competitively priced with a strong focus on customer satisfaction.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Working Process section end */}
        </div>
    )
}

export default ServiceSeven